import React from 'react';
import { DeliverySectionContext } from './DeliverySectionContext';
export function withDeliverySection(Component) {
  return props => {
    const {
      _deliverySectionData,
      ...otherProps
    } = props;
    return /*#__PURE__*/React.createElement(DeliverySectionContext.Provider, {
      value: _deliverySectionData
    }, /*#__PURE__*/React.createElement(Component, otherProps));
  };
}
//# sourceMappingURL=withDeliverySection.js.map